import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MongoliaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15505'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15505)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#146BBC'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#E43642'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.334 14H20.0007V0H13.334V14Z'
					fill='#E43642'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.80906 7.46667H2.85668L3.33287 7L3.80906 7.46667ZM1.9043 8.4H2.85668L2.85668 9.8C2.85668 9.54227 3.06988 9.33333 3.33287 9.33333C3.5958 9.33333 3.80897 9.54218 3.80906 9.79983L3.80906 8.4H4.76144V11.2H3.80906L3.80906 10.2667V9.8C3.80906 10.0577 3.59586 10.2667 3.33287 10.2667C3.06992 10.2667 2.85674 10.0578 2.85668 9.80012V10.2667L2.85668 11.2H1.9043V8.4ZM2.85668 10.2667H3.33287H3.80906L3.33287 11.2L2.85668 10.2667ZM3.33287 8.4H3.80906L3.33287 9.33333L2.85668 8.4H3.33287ZM3.33287 8.4C3.06988 8.4 2.85668 8.19107 2.85668 7.93333C2.85668 7.6756 3.06988 7.46667 3.33287 7.46667C3.59586 7.46667 3.80906 7.6756 3.80906 7.93333C3.80906 8.19107 3.59586 8.4 3.33287 8.4Z'
					fill='url(#paint0_linear_2332_15505)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_15505'
					x1='1.9043'
					y1='7'
					x2='1.9043'
					y2='11.2'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#F8D246' />
					<stop
						offset='1'
						stopColor='#F9CE2F'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default MongoliaFlagIcon;
